<template>
  <div class="flex code_block">
    <div class="code flex">
      <div class="photo">
        <img :src="`${this.$http.base.storage}${employeeData.photo}`" />
      </div>
      <div class="detailed">
        <div class="text">
          <h1>承攬商危害告知合格證</h1>
          <div class="employee_data flex">
            <div v-for="(item,index) in field" :key="index">
              <template v-for="(val,key,i) in combined">
                <template v-if="key==item.val">
                  <span :key="i">{{item.name}}</span>
                  {{val}}
                </template>
              </template>
            </div>
            <div>
              <span>發證日期</span>
              {{today}}
            </div>
          </div>
        </div>
        <div class="barcode">
          <svg id="barcode" />
        </div>
      </div>
    </div>
    <div class="code flex">
      <div class="code_logo">
        <img src="../assets/images/logo_.png">
      </div>
      <div class="detailed contact">
        <div class="text">
          <h1>緊急聯絡電話</h1>
          <div class="employee_data">
            <div class="tel">
              <span>廠務值班</span>0928-016738
            </div>
            <div class="tel">
              <span>工安電話</span>0928-013251
            </div>
            <div class="tel">
              <span>廠護電話</span>0932-297206
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.code_block {
  justify-content: center;
}
.code {
  position: relative;
  // border-radius: 5px;
  border: 1px solid #ccc;
  padding: 10px;
  margin: 30px 0px;
  // width: 255px;
  // height: 153px;
  width: 342px;
  height: 206.55px;
  justify-content: space-between;
  align-items: center;
  .barcode {
    // width: 100px;
    height: 38px;
    text-align: left;
    margin-left: -10px;
  }
  .code_logo{
    position: absolute;
    opacity: 1;
    z-index: -1;
    top: 80px;
    right: 20px;
    img{
      max-width: 100px;
    }
  }
  .photo {
    flex: 3;
    img {
      max-width: 100%;
    }
  }
  .detailed {
    height: 206.55px;
    margin-left: 10px;
    flex: 7;
    &.contact{
      .text{
        margin:60px 0 0 0;
      }
    }
    .text {
      position: relative;
      margin:40px 0 0 0;
      text-align: left;
      h1 {
        font-size: 16px;
        font-weight: bold;
        margin: 5px 0 7px 0;
      }
      .employee_data {
        flex-wrap: wrap;
        > div {
          font-size: 12px;
          margin: 2px 0;
          width: 140px;
          &.tel{
            margin:5px 0;
          }
        }
      }
    }
  }
}
</style>
<script>
import * as moment from "moment";
import JsBarcode from "jsbarcode";
export default {
  name: "card",
  data() {
    return {
      field: [
        { name: "廠商", val: "vendor_short_name" },
        { name: "姓名", val: "name" },
        { name: "編號", val: "code" },
        { name: "血型", val: "bloodtype" }
      ],
      employeeData: {},
      vendorData: {},
      combined: {}
    };
  },
  computed: {
    today() {
      return moment().format("YYYY-MM-DD");
    }
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$http.api.vendor
        .vendorEmployeeGet(this.$route.query.employee)
        .then(res => {
          this.employeeData = res.data;
          return res.data;
        })
        .then(res => {
          this.$http.api.vendor.vendorBasisGet(res.vendor_id).then(data => {
            this.vendorData = data.data;
            this.combined = { ...this.employeeData, ...this.vendorData };
          });
        });
    },
    barcode() {
      JsBarcode("#barcode", this.$route.query.code, {
        height: 18,
        width: 1,
        fontSize: 10,
        displayValue: false
      });
    }
  },
  mounted() {
    this.barcode();
  }
};
</script>